import React, { useState, useEffect, useRef } from "react";

// eslint-disable-next-line no-unused-vars
import { close, menu } from "../assets";
import { brightripplelogo3 } from "../assets";
import { navLinks } from "../constants";

const Navbar = () => {
  const [active, setActive] = useState("Home");
  // eslint-disable-next-line no-unused-vars
  const [toggle, setToggle] = useState(false);
  const navRef = useRef(null);
  const pillRef = useRef(null);
  const haloRef = useRef(null);

  // Position the active pill to match the active nav item
  useEffect(() => {
    const updatePill = () => {
      if (!navRef.current || !pillRef.current) return;
      const activeEl = navRef.current.querySelector(
        `[data-id="${active.toLowerCase()}"]`
      );
      if (!activeEl) {
        pillRef.current.style.width = "0px";
        if (haloRef.current) haloRef.current.style.width = "0px";
        return;
      }

      const left = activeEl.offsetLeft - (navRef.current.scrollLeft || 0);
      const width = activeEl.offsetWidth;
      pillRef.current.style.left = `${left}px`;
      pillRef.current.style.width = `${width}px`;

      if (haloRef.current) {
        const haloPadding = 12;
        haloRef.current.style.left = `${left - haloPadding}px`;
        haloRef.current.style.width = `${width + haloPadding * 2}px`;
      }
    };

    updatePill();

    window.addEventListener("resize", updatePill);
    const scroller = navRef.current;
    if (scroller)
      scroller.addEventListener("scroll", updatePill, { passive: true });

    return () => {
      window.removeEventListener("resize", updatePill);
      if (scroller) scroller.removeEventListener("scroll", updatePill);
    };
  }, [active]);

  // Scrollspy: observe sections and update active link
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            const link = navLinks.find((n) => n.id === id);
            if (link) setActive(link.title);
          }
        });
      },
      { root: null, rootMargin: "-40% 0px -50% 0px", threshold: 0.1 }
    );

    navLinks.forEach((n) => {
      const el = document.getElementById(n.id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const handleNavClick = (id, title) => {
    setActive(title);
    setToggle(false);
    const section = document.getElementById(id);
    if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav className="floating-nav">
      <img
  src={brightripplelogo3}
  alt="Bright Ripple Logo"
   className="w-[32px] h-[32px] md:w-[40px] md:h-[40px] object-contain rounded-full"
/>
      <div className="flex-1 flex justify-center items-center">
        <ul
          ref={navRef}
          className="list-none flex gap-2 md:gap-4 relative items-center flex-nowrap overflow-x-auto px-2 no-scrollbar"
          style={{ WebkitOverflowScrolling: "touch" }}
        >
          <span ref={haloRef} id="nav-active-halo" className="nav-active-halo" />
          <span ref={pillRef} id="nav-active-pill" className="nav-active-pill" />
          {navLinks.map((nav, index) => (
            <li
              key={nav.id}
              data-id={nav.id}
              className={`nav-item flex-shrink-0 font-poppins font-normal cursor-pointer text-[13px] md:text-[15px] px-2 ${
                active === nav.title ? "text-white" : "text-dimWhite"
              }`}
              onClick={() => handleNavClick(nav.id, nav.title)}
            >
              <a href={`#${nav.id}`}>{nav.title}</a>
            </li>
          ))}
        </ul>
      </div>

      <div className="flex items-center gap-4">
        <a
          className="nav-cta hidden sm:inline-block"
          href="https://calendly.com/brightripple6/30min"
          target="_blank"
          rel="noreferrer"
        >
          Book a Call
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
